/**

Copyright (c) 2021, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <gnu.org/licenses>.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="ion-page">
    <ion-header no-border>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center"> {{ $t('Badge.MyBadges.title') }} </h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" no-bounce>
      <div class="mc-white-container badges-vue">

        <div class="ion-text-center ion-margin-top" v-if="loader">
          <ion-icon size="large" color="light" class="rotating" name="md-sync"></ion-icon>
        </div>

        <div v-if="!loader">
          <!-- My badges -->
          <div class=" d-flex justify-between">
            <h5 class="ion-text-left" style="padding: 0"><strong>Mes badges : </strong> </h5>
          </div>

          <div class="ion-text-center ion-margin-top" v-if="ownedBadges.length == 0">
            {{ $t('Badge.none') }}
          </div>

          <div class="d-flex">
            <img v-for="badge in ownedBadges" style="width:33%; padding:15px;" :src="badge.badgeSummary.icon ? badge.badgeSummary.icon : '/assets/badges.png'" @click="clickBadge(badge)"/>
          </div>

          <div class="d-flex ion-justify-content-center">
            <ion-button  @click="redirectToPublicProfil" size="small" shape="round" color="secondary">
              Voir profil public
            </ion-button>
          </div>

          <!-- My badges in progress -->
          <div class="d-flex justify-between" style="margin-top:10px;">
            <h5 class="ion-text-left" style="padding: 0"><strong>Badges en cours : </strong> </h5>
          </div>
          <ion-item v-for="badge in currentBadges"  @click="setSequences(badge)">
            <ion-row class="text-left d-flex w-100" style="padding-top: 5px;">
              <ion-col size="2" >
                <img style="width:60px;" :src="badge.badgeSummary.icon ? badge.badgeSummary.icon : '/assets/carpool.jpeg'"/>
              </ion-col>
              <ion-col size="10">
                <p style="margin-left:10px; margin-bottom: 5px; margin-top: 0px;"> {{ badge.badgeSummary.badgeTitle}} </p>
                <div style="margin-left:10px; margin-bottom: 10px;" >
                  <span class="mc-progress-bar">
                    <b>{{((badge.badgeSummary.sequences.filter(s => s.validated).length / badge.badgeSummary.sequences.length) * 100).toFixed(0)}}%</b>
                  </span>
                  <ion-progress-bar color="primary" :value="badge.badgeSummary.sequences.filter(s => s.validated).length / badge.badgeSummary.sequences.length
              " ></ion-progress-bar>
                </div>
                <div>{{badge.seeSequences}}</div>
                <div class="sequences" v-if="seeSequences.includes(badge.badgeSummary.badgeId)">
                  <div v-for="sequence in badge.badgeSummary.sequences" style="position: relative" :class="sequence.validated ? 'bold':''">
                    <ion-icon style="position:absolute; left: -18px; top: 1.5px;" v-if="sequence.validated" name="checkmark"></ion-icon>
                    {{sequence.title}}</div>
                </div>
              </ion-col>
              <ion-icon style="position:absolute; right: 0px; top: 28px;" :name="seeSequences.includes(badge.badgeSummary.badgeId) ? 'arrow-dropup' : 'arrow-dropdown'"></ion-icon>
            </ion-row>
          </ion-item>
          <!--
          <ion-item v-if="selectedWaitingBadge > 0">
            <ion-row  class="text-left d-flex align-center w-100">
              <ion-col size="2" >
                <img style="width:60px" :src="getSelectedWaitingBadge().badgeSummary.icon ? getSelectedWaitingBadge().badgeSummary.icon : '/assets/carpool.jpeg'"/>
              </ion-col>
              <ion-col size="10">
                <ion-label style="display: none;">Badges en cours</ion-label>
                <ion-select placeholder="Badges en cours"
                            required
                            :value="selectedWaitingBadge"
                            @ionChange="selectedWaitingBadge = Number($event.target.value)"
                            :cancel-text="$t('Commons.cancel')"
                >
                  <ion-select-option v-for="badge in currentBadges" :key="badge.badgeSummary.badgeId" :value="badge.badgeSummary.badgeId">{{ badge.badgeSummary.badgeTitle }} </ion-select-option>
                </ion-select>
              </ion-col>

              <ion-col size="12"style="padding-bottom:15px; padding-top:5px;">
                <div v-if="getSelectedWaitingBadge()">
                  <span class="mc-progress-bar">
                    {{getSelectedWaitingBadge().badgeSummary.sequences.filter(s => s.validated).length}}/{{getSelectedWaitingBadge().badgeSummary.sequences.length}}
                  </span>
                  <ion-progress-bar color="primary" :value="getSelectedWaitingBadge().badgeSummary.sequences.filter(s => s.validated).length / getSelectedWaitingBadge().badgeSummary.sequences.length
              " ></ion-progress-bar>
                </div>
              </ion-col>
            </ion-row>
          </ion-item>
          -->

          <!-- My badges in progress -->
          <div class="d-flex justify-between" style="margin-top:10px;">
            <h5 class="ion-text-left" style="padding: 0"><strong>Autres badges : </strong> </h5>
          </div>
          <ion-item v-for="badge in otherBadges">
            <ion-row class="text-left d-flex align-center w-100" style="padding-top: 5px;">
              <ion-col size="2" >
                <img style="width:60px;" :src="badge.badgeSummary.icon ? badge.badgeSummary.icon : '/assets/carpool.jpeg'"/>
              </ion-col>
              <ion-col size="10">
                <p style="margin-left:10px;"> {{ badge.badgeSummary.badgeTitle}} </p>
              </ion-col>
            </ion-row>
          </ion-item>

          <!-- checkbox -->
          <!--
          <div class="mc-checkbox d-flex bottom-checkbox">
            <ion-item lines="none">
              <ion-checkbox
                name="displayNone"
                color="primary"
              ></ion-checkbox>
              <ion-label class="no-white-space"><p>Ne plus afficher de message pour une action réalisée</p></ion-label>
            </ion-item>
          </div>
          <div class="mc-checkbox d-flex bottom-checkbox">
            <ion-item lines="none">
              <ion-checkbox
                name="displayNone"
                color="primary"
              ></ion-checkbox>
              <ion-label class="no-white-space"><p>Ne plus afficher de message pour un badge gagné</p></ion-label>
            </ion-item>
          </div>
          -->
          <!-- checkbox -->
          <div class="mc-checkbox d-flex bottom-checkbox">
            <ion-item lines="none">
              <ion-checkbox
                style="margin-right: 20px;"
                name="noProgression"
                color="primary"
                @ionChange="changeGamification($event)"
                :checked="!user.gamification"
              ></ion-checkbox>
              <ion-label class="no-white-space"><p>Ne plus suivre ma progression dans le gain de badges</p></ion-label>
            </ion-item>
          </div>
        </div>

      </div>

    </ion-content>
  </div>
</template>

<script>
  import {toast} from "../../Shared/Mixin/toast.mixin";

  export default {
    name: 'my-badges',
    data () {
      return {
        items: [
          { label: "J'ai covoituré avec 10 personnes différentes" },
          { label: "J'ai parrainé 3 utilisateurs" },
        ],
        selectedWaitingBadge : 0,
        ownedBadges: [],
        currentBadges: [],
        otherBadges: [],
        seeSequences: [],
        loader : true
      }
    },
    created() {
      this.getMyBadges();
    },
    computed: {
      user: {
        get() {
          return this.$store.state.userStore.user;
        }
      },
    },
    mixins: [toast],
    methods: {
      getMyBadges() {
        this.$store.dispatch('getMyBadges').then(resp => {
          this.ownedBadges = resp.data.badges.filter(item => item.earned === true);
          this.currentBadges = resp.data.badges.filter(item => item.earned === false && item.badgeSummary.sequences.find(s => s.validated));
          this.otherBadges = resp.data.badges.filter(item => !(this.ownedBadges.map(o => o.badgeSummary.badgeId).includes(item.badgeSummary.badgeId) || this.currentBadges.map(o => o.badgeSummary.badgeId).includes(item.badgeSummary.badgeId)));
          this.selectedWaitingBadge = this.currentBadges.length > 0 ? this.currentBadges[0].badgeSummary.badgeId : 0;
          this.getAllBadges();
          this.loader = false;
        }).catch(error => {
          this.loader = false;
        })
      },
      redirectToPublicProfil() {
        this.$router.push({name : 'profile-public', params : {id: this.$store.getters.userId }});
      },
      clickBadge(badge) {
        this.presentToast('Badge : ' + badge.badgeSummary.badgeTitle, "success");
      },
      getSelectedWaitingBadge() {
        return this.currentBadges.find(item => item.badgeSummary.badgeId == this.selectedWaitingBadge)
      },
      setSequences(badge) {
        const f = this.seeSequences.findIndex(item => item == badge.badgeSummary.badgeId)
        if (f >= 0) {
          this.seeSequences.splice(f, 1);
        } else {
          this.seeSequences.push(badge.badgeSummary.badgeId)
        }
        console.log(this.seeSequences);
      },
      changeGamification(event) {
        this.user.gamification = !event.detail.checked;
        this.$store.dispatch('updateUser', this.user)
          .then(res => {
            this.presentToast(this.$t("UpdateProfile.success"), 'success')
          })
          .catch(err => {
            this.presentToast(this.$t("Commons.error"), 'danger')
          });
      }
    }
  }
</script>

<style lang="scss">
  .top-message {
    background-color: #f5f6fa;
    color: var(--ion-color-primary);
    padding: 0px 0px;
    margin-top: -20px;
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
  }

  .badges-vue p {
    font-size: 0.9rem;
    color: #000000;
  }

  ion-select {
    max-width: 90%;

    .select-text {
      white-spece: normal;
    }
  }
  ion-select-option {
    padding-left: 5px;
  }
  .mc-progress-bar {
    position: absolute;
    z-index: 1;
    margin-left: calc(50% - 15px);
    margin-top: 3px;
  }

  .bold {
    font-weight: bold;
  }

  .sequences {
    font-size: 0.8rem;
    margin-left:10px;
    margin-bottom: 10px;
  }
</style>
